import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trainingTime',
  pure: false
})
export class TrainingTimePipe implements PipeTransform {
  public timeleft: any;
  public countDownDate:any;
  public countDownDays:any;
  public countDownHours:number=0;
  public countDownMins:number=0;
  public countDownSecs:number=0;
  public calcEstimatedTime:any;
  public result:any = "Starting...";

  transform(estimatedTime: any, args?: any): any {
          
          this.countDownDate = new Date(args["$date"]);
          this.countDownDate.setSeconds(this.countDownDate.getSeconds() + estimatedTime);
            
            let now = new Date().getTime();
            let timeleft = this.countDownDate - now;
            
            // Calculating days, hours, minutes
            this.countDownDays = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            this.countDownHours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.countDownMins = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            this.countDownSecs = Math.floor((timeleft % (1000 * 60)) / 1000);
            if(this.countDownDays >= 1) {
              this.result = "Training will take more than a day"
            }
            if(this.countDownHours < 1) {
              this.result = String(this.countDownMins) + " minutes left to finish";
            } else {
              this.result = String(this.countDownHours) + " hr " + String(this.countDownMins) + " minutes left to finish";
            }
            if(this.countDownDays <= 0 && this.countDownHours <=0 && this.countDownMins <= 0 && this.countDownSecs <=0) {
              this.result = "";
            }
            if(this.countDownDays <= 0 && this.countDownHours <=0 && this.countDownMins <= 1) {
              this.result = "Almost done. Please wait...";
            }
    return this.result;
  }
}
